
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/soluzioni",
      function () {
        return require("private-next-pages/soluzioni/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/soluzioni"])
      });
    }
  